import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  space,
  borders,
  borderColor,
  borderRadius,
  width,
  propTypes,
  maxWidth,
  minWidth,
  minHeight,
  maxHeight,
  flex,
  flexDirection,
  flexWrap,
  flexBasis,
  alignItems,
  justifyContent,
  color,
  top,
  right,
  bottom,
  display,
  left,
  backgroundImage,
  backgroundPosition,
  backgroundRepeat,
  backgroundSize,
  boxShadow,
  justifySelf,
  alignSelf,
  order,
} from 'styled-system';
import CleanElement from 'clean-element';

import {
  height,
  hoverShadowEffect,
  hoverRemoveFilterEffect,
  responsiveBackgroundSize,
} from '../helpers/style';
import { getAnimationCss } from './Animation';

const CleanFlex = CleanElement('div');

CleanFlex.propTypes = {
  ...propTypes.wrap,
  ...propTypes.borderColor,
  ...propTypes.maxWidth,
  ...propTypes.minWidth,
  ...propTypes.minHeight,
  ...propTypes.maxHeight,
  ...propTypes.borderBottom,
  ...propTypes.borderTop,
  ...propTypes.borderRight,
  ...propTypes.borderLeft,
  ...propTypes.borderRadius,
  ...propTypes.flexDirection,
  ...propTypes.textAlign,
  ...propTypes.zIndex,
  ...propTypes.backgroundImage,
  ...propTypes.responsiveBackgroundSize,
  ...propTypes.backgroundPosition,
  ...propTypes.backgroundRepeat,
  ...propTypes.justifyContent,
  ...propTypes.alignItems,
  ...propTypes.justifySelf,
  ...propTypes.alignSelf,
  ...propTypes.order,
  ...propTypes.flexWrap,
  ...propTypes.flexBasis,
  boxSizing: PropTypes.string,
  hover: PropTypes.bool,
  hoverShadow: PropTypes.bool,
  hoverRemoveFilter: PropTypes.bool,
  rbgSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
  ]),
  colorFill: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverColorFill: PropTypes.string,
  animationName: PropTypes.string,
  fillMode: PropTypes.string,
  overflow: PropTypes.string,
  overflowX: PropTypes.string,
  overflowY: PropTypes.string,
};

const ExtendedFlex = styled(CleanFlex)`
  ${space}
  ${width}
  ${height}
  ${borders}
  ${borderColor}
  ${borderRadius}
  ${maxWidth}
  ${minWidth}
  ${minHeight}
  ${maxHeight}
  ${flexDirection}
  ${alignItems}
  ${justifyContent}
  ${color}
  ${flexWrap}
  ${flexBasis}
  ${top}
  ${right}
  ${bottom}
  ${left}
  ${backgroundImage}
  ${responsiveBackgroundSize}
  ${backgroundPosition}
  ${backgroundRepeat}
  ${backgroundSize}
  ${display}
  ${flex}
  ${boxShadow}
  ${justifySelf}
  ${alignSelf}
  ${order}
  ${({ overflow }) => (overflow !== undefined ? { overflow } : {})}
  ${({ overflowX }) => (overflowX !== undefined ? { overflowX } : {})}
  ${({ overflowY }) => (overflowY !== undefined ? { overflowY } : {})}
  box-sizing: ${(props) => props.boxSizing || 'border-box'};
  position: ${(props) => props.position || 'static'};
  opacity: ${({ opacity = '1' }) => opacity};
  transition: ${(props) => props.transition || 'all 0s 0s ease'};
  z-index: ${(props) => props.zIndex || 'auto'};

  &:hover {
    box-shadow: ${(props) => (props.hoverShadow ? hoverShadowEffect : 'none')};
    cursor: ${(props) => (props.hover ? 'pointer' : 'auto')};
    ${(props) => (props.hoverRemoveFilter ? hoverRemoveFilterEffect : '')}
  }

  ${getAnimationCss}
`;

ExtendedFlex.defaultProps = {
  display: 'flex',
};

export default ExtendedFlex;
